import { MessageContent } from '../../../Content/MessageContent/MessageContent';
import { MessageLimiter } from '../../../Content/MessageLimiter';

type TopicContentProps = {
  heightLimit: number;
  content: string;
  embeds: string | undefined;
  status: string;
  shouldHandleDsaDisplay?: boolean;
  className?: string;
  onLimiterClick?: () => void;
  noLimiter?: boolean;
};

export const TopicContent = ({
  heightLimit,
  content,
  embeds,
  status,
  shouldHandleDsaDisplay,
  className,
  onLimiterClick,
  noLimiter,
}: TopicContentProps) => {
  const fullContent = (
    <MessageContent
      content={content}
      embeds={embeds}
      status={status}
      shouldHandleDsaDisplay={shouldHandleDsaDisplay}
      className={className}
    />
  );

  const limitedContent = (
    <MessageLimiter limit={heightLimit} onLimiterClick={onLimiterClick}>
      {fullContent}
    </MessageLimiter>
  );

  return noLimiter ? fullContent : limitedContent;
};
